'use strict';

const Accordion = {
    init: function () {
        const toggleButtons = document.querySelectorAll('.toggle-button');

        if (toggleButtons.length > 0) {
            toggleButtons.forEach(button => {
                button.addEventListener('click', () => {
                    const container = button.closest('.f-accordion');
                    const isExpanded = button.getAttribute('aria-expanded') === 'true';

                    // Close opened accordion
                    const previousActiveButton = container.querySelector('.toggle-button.active');
                    if (previousActiveButton) {
                        previousActiveButton.setAttribute('aria-expanded', 'false');
                        previousActiveButton.classList.remove('active');
                        const content = previousActiveButton.nextElementSibling;
                        if (content) {
                            content.classList.remove('active');
                            content.setAttribute('aria-hidden', 'true');
                        }
                    }


                    // Toggle the clicked accordion
                    if (!isExpanded) {
                        button.setAttribute('aria-expanded', 'true');
                        button.classList.add('active');

                        const toggleContent = button.nextElementSibling;
                        if (toggleContent) {
                            setTimeout(() => {
                                toggleContent.classList.add('active');
                                toggleContent.setAttribute('aria-hidden', 'false');
                            }, 250);
                        }
                    } else {
                        button.setAttribute('aria-expanded', 'false');
                        button.classList.remove('active');

                        const toggleContent = button.nextElementSibling;
                        if (toggleContent) {
                            setTimeout(() => {
                                toggleContent.classList.remove('active');
                                toggleContent.setAttribute('aria-hidden', 'true');
                            }, 250);
                        }
                    }
                });
            });
        }
    },
};

export default Accordion;